// Define padding options as const array for runtime validation
const PADDING_OPTIONS = ['none', 'xxxxsmall', 'xxxsmall', 'xxsmall', 'xsmall', 'small', 'base', 'medium', 'large', 'xlarge', 'xxlarge', 'xxxlarge'];

// shared type with only PaddingOptions values

// Gap prop type that works similar to padding

export { PADDING_OPTIONS as P };
//# sourceMappingURL=PaddingOptions-CB0CIxyr.js.map
